// @ts-ignore
import tw from 'twin.macro'
import { ThreeDots } from 'react-loading-icons'
import React from 'react'
import pickBy from 'lodash/pickBy'

const sizes = {
  xl: ['14px', '16px', '20px'],
}

export const Button = props =>
  (({
    onClick = () => { },
    className,
    AppendIcon,
    primary,
    primaryOutline,
    whiteOutline, // New prop
    lightGlow,
    transparent,
    children,
    disabled = false,
    size = 'xl',
    type,
    loading = false,
  } = props) => (
    <button
      {...pickBy(props, (v, k) => k.includes('attr-'))}
      type={type}
      onClick={onClick}
      className={className}
      disabled={loading || disabled}
      css={[
        tw`text-center hover:opacity-60 transition-opacity capitalize duration-200 flex items-center shrink-0 justify-center`,
        primary && tw`bg-primary`,
        !children && AppendIcon,
        transparent && tw`bg-transparent`,
        primaryOutline && tw`bg-transparent border-primary text-primary`,
        whiteOutline && tw`border-2 border-white text-white shadow-xl`,
        lightGlow && `background: rgba(255, 255, 255, 0.16); border: none;`,
        sizes[size] && `font-size: ${sizes[size][1]};`,
        sizes[size] && `line-height: ${sizes[size][0]};`,
        (loading || disabled) && tw`!cursor-not-allowed !bg-gray-400`,
      ]}
    >
      <div css={[sizes[size] && children && `height: ${sizes[size][1]};`]}>
        {loading === true || loading?.loading === true ? (
          <ThreeDots
            fill={primaryOutline ? 'var(--color-primary)' : 'white'}
            height={'100%'}
            width={'100%'}
          />
        ) : (
          <div className="flex items-center">
            {AppendIcon && (
              <span
                className={
                  'append-icon capitalize mr-[12px] lg:mr-[8px] inline-block'
                }
                css={[!children && tw`mr-0`]}
              >
                {typeof AppendIcon === 'object' && !AppendIcon?.render ? (
                  AppendIcon
                ) : (
                  <AppendIcon />
                )}
              </span>
            )}
            {children}
          </div>
        )}
      </div>
    </button>
  ))(props)

export default Button
